import React from "react";
import ArrowBlackIcon from '../../assets/svg/arrow-down-black.svg';
import AvatarCard from "../avatar-card";

interface MenuDropdownItem {
    label: string;
    value: string;
}

interface MenuDropdownProps {
    title: string;
    items: MenuDropdownItem[];
    value: string;
    profileImageUrl?: string;
    profileSubTitle?: string;
    className?: string;
}

export function MenuDropdown({ title, items, value, profileImageUrl, profileSubTitle, className }: MenuDropdownProps) {
    const [isOpen, setIsOpen] = React.useState(false);

    const handleMouseEnter = () => setIsOpen(true);
    const handleMouseLeave = () => setIsOpen(false);

    const handleItemClick = (url: string) => {
        window.location.href = url;
    };

    return (
        <div
            className="relative"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className="inline-flex justify-end w-full flex-row">
                {profileImageUrl && (
                    <AvatarCard
                        isViewMore={false}
                        title={title}
                        subTitle={profileSubTitle}
                        imageUrl={profileImageUrl}
                        onClickHandler={() => handleItemClick(value)}
                        size={'sm'}
                        className="profile-header"
                        avatarClassName="flex-shrink-0"
                    />
                )}
                <button onClick={() => handleItemClick(value)} className="text-sm text-labelTextCol font-aeonikReg py-2 px-2 rounded-md flex justify-center items-center !leading-[normal] menu-items">
                    {profileImageUrl ? null : <span>{title}</span>}
                    {items.length > 0 ? <img src={ArrowBlackIcon} alt='' className=" mt-1" /> : null}
                </button>
            </div>

            {isOpen && (
                <div className={`absolute w-[max-content] max-w-[25rem] bg-white rounded-md shadow-shadowAll z-10 ${className ? className : ''}`}>
                    {items.map((item, index) => (
                        <div
                            key={index}
                            onClick={() => handleItemClick(item.value)}
                            className="text-sm px-3 py-2 text-labelTextCol font-aeonikReg hover:bg-primary hover:text-white cursor-pointer"
                        >
                            {item.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MenuDropdown;